/**
 * The one place the update feature reloads the document.
 *
 * A module of its own for exactly one reason: specs replace it
 * (`vi.mock('@/pwa/reload')`), because a spec must never actually call
 * happy-dom's `location.reload()`. Everything that reloads for an update —
 * `register.ts` (`reloadForUpdate()`), `hard-reload.ts`, the update wall's
 * Reload button and the back/forward-cache guard in `update-session.ts` — goes
 * through here, so one mock covers them all.
 */
export function reloadPage(): void {
  window.location.reload();
}
